// extracted by mini-css-extract-plugin
export default {"Technologies":"Technologies_Technologies__X5zaf","Technologies__Title":"Technologies_Technologies__Title__d+RHD"};